import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy path — Offer became Parts (PN card). */
export const Route = createFileRoute("/offer")({
  beforeLoad: () => {
    throw redirect({ to: "/parts" });
  },
  component: () => null,
});
